import { FluentProvider, webLightTheme } from '@fluentui/react-components';
import React from 'react';

interface FluentThemeProviderProps {
  children: React.ReactNode;
}

export const FluentThemeProvider: React.FC<FluentThemeProviderProps> = ({ children }) => {
  return (
    <FluentProvider theme={webLightTheme}>
      {children}
    </FluentProvider>
  );
};
